<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <ng-container *ngIf="showLegacy; then legacyDeviceTemplate else regulationDeviceTemplate">
                </ng-container>
                <ng-template #legacyDeviceTemplate>
                  <tbody>
                    <tr>
                      <th class="col-sm-6">EUDAMED ID</th>
                      <th class="col-sm-6">EUDAMED ID Issuing Agency</th>
                    </tr>
                    <tr>
                      <td><label controlName="eudamedId"></label></td>
                      <td><label controlName="eudamedIdIssuingAgency"></label></td>
                    </tr>
                  </tbody>
                </ng-template>
                <ng-template #regulationDeviceTemplate>
                  <tbody>
                    <tr>
                      <th class="col-sm-6">Primary DI</th>
                      <th class="col-sm-6">Issuing Agency</th>
                    </tr>
                    <tr>
                      <td><label controlName="udiDI"></label></td>
                      <td><label controlName="agency"></label></td>

                    </tr>
                  </tbody>
                </ng-template>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <ng-container *ngIf="showLegacy; then legacyModelTemplate else regulationModelDeviceTemplate">
                  </ng-container>
                  <ng-template #legacyModelTemplate>
                    <tr>
                      <th class="col-sm-6">EUDAMED DI</th>
                      <th class="col-sm-6">EUDAMED DI Issuing Agency</th>
                    </tr>
                    <tr>
                      <td>
                        <label controlName="budi"></label>
                      </td>
                      <td><label controlName="bAgency"></label></td>
                    </tr>
                  </ng-template>
                  <ng-template #regulationModelDeviceTemplate>
                    <tr>
                      <th class="col-sm-6">Basic UDI-DI</th>
                      <th class="col-sm-6">Issuing Agency</th>
                    </tr>
                    <tr>
                      <td>
                        <label controlName="budi"></label>
                      </td>
                      <td><label controlName="bAgency"></label></td>
                    </tr>
                  </ng-template>
</tbody>                
              </table>

            </td>
          </tr>

          <tr>
            <td class="no-left-padding">
              <table formArrayName="tradeNamesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Brand or Trade Name(s)</th>
                    <th class="col-sm-6">Language</th>
                  </tr>
                  <ng-container *ngIf="tradeNamesForm?.controls?.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}" *ngFor="let name of tradeNamesForm.controls; let i = index">
                    <td>
                      <label controlName="value"></label>
                    </td>
                    <td> <label controlName="language"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>

            <td class="no-right-padding">
              <table formArrayName="deviceDescriptionForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Description</th>
                    <th class="col-sm-6">Language</th>
                  </tr>
                  <ng-container *ngIf="deviceDescriptionForm.controls.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}" *ngFor="let name of deviceDescriptionForm.controls; let i = index">
                    <td class="breakAll"> <label controlName="value"></label></td>
                    <td> <label controlName="language"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>URL for Additional Information</th>
                  </tr>
                  <tr>
                    <td> <label
                        controlName="urlForAdditionalInfo"></label>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Catalog or Reference Number</th>
                  </tr>
                  <tr>
                    <td><label
                        controlName="referenceOrCatalogNumber"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr *ngIf="!sppDevice && !isSwissdamedLegacyDeviceRegulation()">
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Quantity of Device</th>
                  </tr>
                  <tr>
                    <td><label controlName="quantityOfDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="no-right-padding" *ngIf="!isSwissdamedIvddDeviceRegulation()">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Unit of Use DI</th>
                    <th class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td><label controlName="unitOfUseDi"></label></td>
                    <td><label
                        controlName="unitOfUseDiAgency"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="no-left-padding">

              <table formArrayName="emdnCodesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>EMDN Code(s)</th>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tbody>
                          <ng-container *ngIf="emdnCodesForm?.controls?.length; else emptyTemplate1field">
                          <tr formGroupName="{{i}}" *ngFor="let code of emdnCodesForm.controls; let i = index">
                            <td><label controlName="emdnCode"></label></td>
                          </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                </tbody>
              </table>
            </td>

            <td class="no-right-padding" *ngIf="dataScope?.toLowerCase() !== 'swissdamed'">
              <table formArrayName="cndCodesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>CND Code</th>
                  </tr>
                  <ng-container *ngIf="cndCodesForm?.controls?.length; else emptyTemplate1field">
                  <tr>
                    <td>
                          <tr formGroupName="{{i}}" *ngFor="let code of cndCodesForm.controls; let i = index">
                            <label controlName="cndCode"></label>
                          </tr>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>

            </td>
          </tr>
          <tr *ngIf="!isSwissdamedLegacyDeviceRegulation() && !isSwissdamedIvddDeviceRegulation()">
            <td class="no-left-padding"  *ngIf="!sppDevice">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Direct Marking DI</th>
                    <th class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td><label controlName="directMarkingDI"></label></td>
                    <td><label
                        controlName="directMarkingDIAgency"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td [ngClass]="sppDevice ? 'no-left-padding' : 'no-right-padding'">
              <table formArrayName="secondaryDiForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Secondary DI</th>
                    <th class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <ng-container *ngIf="secondaryDiForm?.controls?.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}" *ngFor="let item of secondaryDiForm.controls; let i = index">
                    <td><label controlName="diValue"></label></td>
                    <td><label controlName="diAgency"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr *ngIf="!isSwissdamedLegacyDeviceRegulation() && !isSwissdamedIvddDeviceRegulation()">
            <td class="no-left-padding">
              <table class="table table-inner table-condensed table-striped table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Production Identification Controlled By:</th>
                    <th class="col-sm-6"></th>
                  </tr>
                  <tr>
                    <td>Expiration Date?</td>
                    <td><label
                        controlName="isExpirationDate"></label></td>
                  </tr>
                  <tr>
                    <td>Manufacturing Date?</td>
                    <td><label
                        controlName="isManufacturingDate"></label></td>
                  </tr>
                  <tr>
                    <td>Lot or Batch Number?</td>
                    <td><label
                        controlName="isLotOrBatchNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Serial Number?</td>
                    <td><label
                        controlName="isSerialNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Software Version?</td>
                    <td><label
                        controlName="isSwVersion"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
